import Marquee3k from 'marquee3000';

export function initMarquee() {
    Marquee3k.init({
        selector: 'js-marquee', // define a custom classname
    });
}
